
<template>
	<div class="flex justify-center items-center" style="height: 100%">
		<div
			v-if="onePs.linkedin_url == 'loading' && onePs.is_linkedin_employees_fetch != 1"
			class="sloader"
		></div>
		<div v-else>
			<div
				v-if="
					onePs.linkedin_url &&
					onePs.linkedin_url != 'loading' &&
					['https', 'http', 'www', 'linkedin'].some((el) =>
						onePs.linkedin_url.includes(el)
					)
				"
				:text="onePs.linkedin_url"
			>
				<a target="_blank" :href="onePs.linkedin_url">
					<feather-icon
						icon="LinkedinIcon"
						class="m-0 cursor-pointer"
						style="color: #0a66c2"
					/>
				</a>
			</div>
			<div v-else>-</div>
		</div>
	</div>
</template>
                                  
                                  <script>
export default {
	props: {
		onePs: Object, // Pass the data object that contains the `id` and `url`
	},
	data() {
		return {
			onePs: {},
		};
	},
	created() {
		this.onePs = this.params.data;
	},
};
</script>
<style>
</style>
